// HIGH SPEED SHOP — Cart Interactions
import { updateCartBadge, showToast, getCartCount, storeUrl } from './hs_utils';

export function initCart() {
	// Update badge on page load
	updateCartBadge(getCartCount());

	// Add to cart buttons
	document.addEventListener('click', function (e) {
		const btn = e.target.closest('.hs-btn-add-cart');
		if (!btn) return;

		e.preventDefault();
		const itemCode = btn.dataset.itemCode;
		if (!itemCode) return;

		addToCart(itemCode, 1, btn);
	});

	// Buy Now button
	document.addEventListener('click', function (e) {
		const btn = e.target.closest('.hs-btn-buy-now');
		if (!btn) return;
		e.preventDefault();

		if (frappe.session.user === 'Guest') {
			window.location.href = storeUrl('/login') + '?redirect-to=' + encodeURIComponent(window.location.pathname);
			return;
		}

		const itemCode = btn.dataset.itemCode;
		if (!itemCode) return;

		const qtyInput = document.getElementById('hs-pdp-qty');
		const qty = qtyInput ? parseInt(qtyInput.value) || 1 : 1;

		btn.disabled = true;
		btn.innerHTML = '<span class="hs-spinner"></span>';

		frappe.call({
			method: 'high_speed_shop.high_speed_shop.api.cart.update_cart',
			args: { item_code: itemCode, qty: qty },
			callback: function () {
				window.location.href = storeUrl('/checkout');
			},
			error: function () {
				showToast(__('Could not process'), 'danger');
				btn.disabled = false;
				btn.innerHTML = __('Buy Now');
			},
		});
	});

	// Cart drawer close
	document.addEventListener('click', function (e) {
		if (e.target.closest('.hs-drawer-close')) {
			closeCartDrawer();
		}
		if (e.target.classList.contains('hs-drawer-overlay')) {
			closeCartDrawer();
		}
	});
}

export function addToCart(itemCode, qty, btn) {
	// Redirect to login if guest
	if (frappe.session.user === 'Guest') {
		window.location.href = storeUrl('/login') + '?redirect-to=' + encodeURIComponent(window.location.pathname);
		return;
	}

	if (btn) {
		btn.disabled = true;
		btn.innerHTML = '<span class="hs-spinner"></span>';
	}

	frappe.call({
		method: 'high_speed_shop.high_speed_shop.api.cart.update_cart',
		args: { item_code: itemCode, qty: qty },
		callback: function (r) {
			if (r.message) {
				const count = getCartCount();
				updateCartBadge(count + 1);
				showToast(__('Added to cart'));
			}
		},
		error: function () {
			showToast(__('Could not add to cart'), 'danger');
		},
		always: function () {
			if (btn) {
				btn.disabled = false;
				btn.innerHTML = `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg> ${__('Add to Cart')}`;
			}
		},
	});
}

export function closeCartDrawer() {
	const drawer = document.querySelector('.hs-cart-drawer');
	const overlay = document.querySelector('.hs-drawer-overlay');
	if (drawer) drawer.classList.remove('hs-drawer-open');
	if (overlay) overlay.classList.remove('hs-drawer-open');
}

export function openCartDrawer() {
	const drawer = document.querySelector('.hs-cart-drawer');
	const overlay = document.querySelector('.hs-drawer-overlay');
	if (drawer) drawer.classList.add('hs-drawer-open');
	if (overlay) overlay.classList.add('hs-drawer-open');
}
